// @flow

class HttpError {
  status: number
  data: any

  constructor(status: number, data: any) {
    this.status = status
    this.data = data
  }
}

export default HttpError



// WEBPACK FOOTER //
// ./src/api/HttpError.js